<template>
</template>

<script>
	import * as turf from "@turf/turf";
	import {mapState} from "vuex";
	import * as randomPoint from "random-points-on-polygon";
	import * as moment from "moment";
	import * as workerTimers from "worker-timers";

	import WorkersStyles from "./Workers/Styles.js";
	import WorkersActions from "./Workers/Actions.js";

	import {get} from "idb-keyval";

	export default {
		name: "GameWorkers",
		mixins: [WorkersStyles, WorkersActions],
		data() {
			return {
				polygon: null,
				zone: null,
				pictures: {},
				asset_animation: {}
			};
		},
		computed: {
			...mapState([
				"filteredWorkers",
				"load",
				"time_to",
				"muster",
				"floor_level",
				"clock",
				"time",
				"day",
				"path_features",
				"features",
				"workers",
				"worker_status",
				"position",
				"speed",
				"lock",
				"sprites",
				"vehicles",
				"location",
				"companies",
				"zones",
				"paths",
				"vehicle_types",
				"proximity"
			]),
			assets_loaded: {
				get() {
					return this.$store.state.assets_loaded;
				},
				set(value) {
					this.$store.commit("setState", ["assets_loaded", true]);
				}
			},
			map() {
				return this.$store.state.map.map;
			},
			game: {
				get() {
					return this.$store.state.game;
				},
				set(value) {
					this.$store.commit("setState", ["game", value]);
				}
			},
			start_zone() {
				return this.$finder.get("type=start", this.zones);
			},
			drawLayer() {
				return this.$store.state.map.drawLayer;
			},
			assetsLayer: {
				get() {
					return this.$store.state.map.assetsLayer;
				},
				set(value) {
					this.$store.commit("setState", ["map.assetsLayer", value]);
				}
			},
			worker_profiles() {
				return this.$config.worker_profiles;
			},
			routines() {
				return this.$config.routines;
			},
			efficiency_mid() {
				return this.$config.efficiency_levels.length / 2;
			},
			start_time() {
				return this.$config.start_time;
			},
			end_time() {
				return this.$config.end_time;
			}
		},
		watch: {
			time() {
				this.setDestination();
				this.takeBreak();
				this.safetyEvents();

				this.moveAssets();
			},
			time_to() {},
			speed() {
				for (let i in this.workers) {
					let worker = this.workers[i];
					worker.speed = this.getWorkerSpeed(worker);
					let $sprite = this.sprites[worker.id];
					$sprite.setSpeed(worker.speed);
				}
			},
			filteredWorkers() {
				this.filerWorkersOnMap();
			},
			load() {
				if (this.load != false) this.loadWorkers();
			}
		},
		async mounted() {
			await this.init();
		},
		methods: {
			async init() {
				var that = this;

				this.assetsLayer = new ol.source.Vector({
					wrapX: false,
					updateWhileAnimating: true,
					updateWhileInteracting: true
				});
				var layer = new ol.layer.Vector({
					source: this.assetsLayer
				});
				this.map.addLayer(layer);

				this.polygon = this.features[this.start_zone.id].turf;
				await this.createWorkers();

				this.game = new ol.Game({
					map: this.map
				});
				this.game.start();
			},
			moveAssets() {
				if (!this.assets_loaded) return;

				this.game.on("render", (e) => {
					[this.workers, this.vehicles].forEach((assets) => {
						for (let i in assets) {
							let asset = assets[i];
							let is_vehicle = this.$asset.isVehicle(asset)
							let $sprite = is_vehicle ? this.vehicle_sprites[asset.id] : this.sprites[asset.id];

							e.dt = e.dt / 1000 + 1;

							if (this.time_to === null) $sprite.setSpeed(0);
							else $sprite.setSpeed(asset.speed);

							$sprite.move(e);

							if (is_vehicle) continue;

							let worker = asset;
							// detect proximity
							// if (!worker.in_vehicle && worker.zone.id) {
							// 	let close_workers = this.$finder.all({'zone.id': worker.zone.id}, this.workers);
							// 	for (let i in close_workers) {
							// 		let other = close_workers[i];
							// 		if (i == worker.id || other.in_vehicle) continue;

							// 		let distance =  turf.distance(this.$geo.toTurf(worker.coordinates), this.$geo.toTurf(other.coordinates)); // distance in kilometers
							// 		if (distance <= 0.01) { // proximity alert
							// 			let pair = [worker.id, other.id].sort(function(a, b){return a-b}).join("-");
							// 			pair += "@"+this.day+":"+this.time;
							// 			if (this.proximity.alert[pair] == undefined) {
							// 				let data = {'zone_id': worker.zone.id, 'workers': [worker.id, other.id], 'day': this.day, 'time': this.time, 'clock': this.clock, 'status': 'active', 'duration': 0 };

							// 				this.$set(this.proximity.alert, pair, data);

							// 			}
							// 		}
							// 	}
							// }
							// clear proximity
							// if (this.time % 60) {
							// 	let alerts = this.proximity.alert;//this.$finder.all({'workers': [worker.id], 'status': 'active'}, this.proximity.alert);
							// 	for (let i in alerts) {
							// 		let alert = alerts[i];
							// 		if (alert.status == 'clear') continue;
							// 		for (let j in alert.workers) {
							// 			let worker_id = alert.workers[j];
							// 			if (worker_id == worker.id) continue;

							// 			let other = this.workers[worker_id];
							// 			let distance =  turf.distance(this.$geo.toTurf(worker.coordinates), this.$geo.toTurf(other.coordinates)); // distance in kilometers
							// 			if (distance > 0.01) {
							// 				alert.status = 'clear';
							// 				alert.duration = this.time - alert.time;
							// 			}
							// 		}
							// 	}
							// }



						}
					});
					this.game.removeEventListener("render");
				});
			},
			async createWorkers() {
				if (Object.keys(this.workers).length > 0) return;

				if (this.load) {
					await this.loadWorkers();
					return;
				}

				let id = 0;
				let that = this;
				this.pictures = this.$config.data.pictures;

				for (let i in this.companies) {
					let company = this.companies[i]

					for (let worker_type in company.workers) {
						var points = randomPoint(company.workers[worker_type], this.polygon);

						for (let j in points) {
							id++;

							let point = ol.proj.transform(
								points[j].geometry.coordinates,
								"EPSG:4326",
								"EPSG:3857"
							);

							let worker = {
								id: id,
								type: worker_type,
								floor_level: this.start_zone.floor_level,
								route: null,
								status: "at-zone",
								zone: this.start_zone,
								polygon: this.polygon,
								first_name: this.$finder.random(this.$config.data.fname),
								last_name: this.$finder.random(this.$config.data.lname),
								badge_number: Math.floor(Math.random()*9000000) + (1000000 + parseInt(id)),
								job: this.$finder.random(this.$config.worker_types[worker_type].jobs),
								stairs_to: null,
								override: false,
								stairs_time: null,
								end: false,
								mode: "normal",
								alert: false,
								destination: null
							};

							if (Object.keys(this.pictures).length == 0)
								this.pictures = this.$config.data.pictures;
							let picture = this.$finder.random(this.pictures);
							picture = require(`assets/img/pictures/${picture}`);
							worker.picture = picture;//`src/assets/img/pictures/${picture}`;
							delete this.pictures[parseInt(picture)];

							worker.efficiency = this.$finder.random(
								this.$config.efficiency_levels
							);
							worker.safety = this.$finder.random(this.$config.safety_levels);

							// chance for efficiency: break time frequency
							worker.chance = worker.efficiency * 5;
							worker.chance_bad = (55 - worker.chance) / (3600 * 4 * 100); // that means 25% of chance for worse case (efficiency being 1) at each 4H .
							worker.chance_good = (worker.efficiency * 5) / (60 * 10 * 100); // chance for asset to correct itself each 10min

							// chance for safety: frequency of safety events -- fall, man-down, entering restricted area
							worker.safety_chance = worker.safety * 5;
							worker.safety_chance_bad =
								(55 - worker.safety_chance) / (3600 * 12 * 100); // 50% of chance for worse case (safety being 1) at each 12h
							worker.safety_chance_good = (worker.safety * 5) / (60 * 10 * 100); // chance of a worker to get out of a restricted area on its own.

							worker.company = company;
							worker.speed = this.getWorkerSpeed(worker);

							this.$set(this.filteredWorkers, worker.id, worker);
							this.$set(this.workers, worker.id, worker);

							worker.coordinates = point;
							this.setSprite(worker);
						}
					}
				}
				this.assets_loaded = true;
			},
			async loadWorkers() {
				let data;
				if (this.load == "sample") data = sample_scenario;
				else data = await get(this.load);

				for (let i in data.workers) {
					let dw = data.workers[i];

					let worker = {
						id: dw.id,
						type: dw.type,
						floor_level: dw.floor_level,
						route: dw.route,
						status: dw.status,
						zone: dw.zone,
						first_name: dw.first_name,
						last_name: dw.last_name,
						badge_number: dw.badge_number,
						job: dw.job,
						override: dw.override,
						stairs_time: dw.stairs_time,
						end: dw.end,
						mode: dw.mode,
						alert: dw.alert,
						destination: dw.destination
					};
					worker.target_zone_type = dw.target_zone_type;
					worker.target_zone_id = dw.target_zone_id;
					worker.picture = dw.picture;

					worker.company = dw.company;

					worker.efficiency = dw.efficiency;
					worker.safety = dw.safety;

					worker.chance = dw.chance;
					worker.chance_bad = dw.chance_bad;
					worker.chance_good = dw.chance_good;

					worker.safety_chance = dw.safety_chance;
					worker.safety_chance_bad = dw.safety_chance_bad;
					worker.safety_chance_good = dw.safety_chance_good;

					if (dw.vehicle_id !== undefined) worker.vehicle_id = dw.vehicle_id;
					if (dw.in_vehicle !== undefined) worker.in_vehicle = dw.in_vehicle;

					worker.speed = this.getWorkerSpeed(worker); //dw.speed;

					this.$set(this.filteredWorkers, worker.id, worker);
					this.$set(this.workers, worker.id, worker);

					worker.coordinates = dw.coordinates;
					this.setSprite(worker);
				}
				this.assets_loaded = true;
			},
			setSprite(worker) {

				let sprite_img = require(`assets/img/sprites/${this.$config.job_types[worker.job].img}`);

				let $sprite = new ol.Sprite({
					position: worker.coordinates,
					src: sprite_img,
					size: 75,
					scale: 0.2,
					frameRate: 0,
					states: {
						idle: {
							line: 0,
							length: 1
						}
					}
				});
				$sprite.id = worker.id;
				$sprite.setId(worker.id);
				$sprite.type = "worker";
				$sprite.scale = 0.2;
				$sprite.size = 75;

				this.assetsLayer.addFeature($sprite);
				$sprite.on('change:direction', e=>{
					if (!worker.simulation) this.position[worker.id][this.day].push({ floor_level: worker.floor_level, time: this.time, day: this.day, clock: this.clock, coordinates: $sprite.getCoordinate(), type: 'sprite-moving'});
				})

				$sprite.on("destination", (e) => {
					if (!worker.simulation) this.position[worker.id][this.day].push({ floor_level: worker.floor_level, time: this.time, day: this.day, clock: this.clock, coordinates: $sprite.getCoordinate(), type: 'sprite-destination'});
					$sprite.setState("idle");
					worker.speed = this.getWorkerSpeed(worker);
					if (worker.status == 'boarding') {
						worker.in_vehicle = true;
						let vehicle = this.vehicles[worker.vehicle_id];
						vehicle.queue = this.$finder.remove(vehicle.queue, worker.id);
						worker.status = 'on-board';
						worker.driver_id = null;
						vehicle.route = null;
						vehicle.on_board.push(worker.id);

						if (vehicle.type != 'transport') {
							worker.status = 'finding-path';
							worker.route = null;
						}
						else {

						}

						// worker.status = 'finding-path';
						// this._moveToZone(worker);
						return;
					}

					else if (worker.status == "finding-path") {
						this._moveToZone(worker);
					}
					else if (worker.status == "going") {

						let vehicle;
						// worker won't have this action when on transportation, it's controlled by the vehicle.
						if (worker.in_vehicle) {
							vehicle = this.vehicles[worker.vehicle_id];
							if (vehicle.type == 'transport') return;
						}

						let route = worker.route.shift();

						if (route.return_vehicle) {
							worker.vehicle_id = null;
							worker.in_vehicle = false;
							if (vehicle) this.$finder.remove(vehicle.on_board, worker.id);
						}

						if (worker.route.length) {

							worker.zone = this.zones[route.zone_id];
							worker.status = "finding-path";
							this._moveToZone(worker);
							return;
						}

						worker.hasMoved = false;
						worker.zone = this.$zone.get(route.zone_id);


						worker.target_zone_id = null;
						worker.status = "at-zone";
						worker.route = null;
						worker.floor_level = worker.zone.floor_level;

						// console.log('w', worker);

						if (!this.lock[worker.id]) worker.override = false;
						else this.lock[worker.id].start = this.time;

						if (worker.mode == "end" && worker.zone.type == 'start' || worker.zone.type == 'end') worker.end = true;
					}
				});
				$sprite.on("change", () => {
					worker.coordinates = $sprite.getCoordinate();
					if (worker.in_vehicle && worker.vehicle_id) {
						let vehicle = this.vehicles[worker.vehicle_id];
						if (vehicle && vehicle.type != 'transport') {
							let $vehicle_sprite = this.vehicle_sprites[vehicle.id];
							$vehicle_sprite.setCoordinate(worker.coordinates);
						}

					}
					if (!worker.target_zone_id || worker.stairs_to) return;

					let target_zone = this.zones[worker.target_zone_id];

					var diff = parseInt(
						Math.abs(worker.floor_level - target_zone.floor_level)
					);

					if (diff == 0) return;

					var features = this.drawLayer.getFeaturesAtCoordinate(worker.coordinates);
					for (var i in features) {
						var feature = features[i];
						if (feature.type == "stairs") {
							$sprite.stop();
							worker.stairs_time = this.time;

							worker.stairs_to = workerTimers.setTimeout(() => {
								if (target_zone) worker.floor_level = target_zone.floor_level;
								else if (worker.zone) worker.floor_level = worker.zone.floor_level;
								$sprite.restart();
								workerTimers.clearTimeout(worker.stairs_to);
								worker.stairs_time = null;
								worker.stairs_to = null;

							}, 15000 * diff / this.speed);
						}
					}
				});

				this.$set(this.sprites, worker.id, $sprite);
				this._resumeWalk(worker);
			},
			getWorkerSpeed(worker) {
				// get speed in m/s
				let speed;

				if (worker.in_vehicle) {
					let vehicle = this.vehicles[worker.vehicle_id];
					if (vehicle) return vehicle.speed;
				}

				let speed_range = [
					(this.$config.walking_speed[0] * 1.609344) / 3.6,
					(this.$config.walking_speed[1] * 1.609344) / 3.6
				];
				speed =
					speed_range[1] +
					((speed_range[0] - speed_range[1]) / 10) * (worker.efficiency - 1);

				return speed;
			},
			setDestination() {
				for (let i in this.workers) {
					let worker = this.workers[i];
					this._workerZoneSchedule(worker);
					this._workerDestination(worker);
				}
			},
			_workerZoneSchedule(worker) {
				if (this.lock[worker.id]) {
					if (this.lock[worker.id].start == null)
						this.lock[worker.id].start = this.time;
					if (
						this.time - this.lock[worker.id].start >
						this.lock[worker.id].duration
					) {
						worker.override = false;
						this.$set(this.lock, worker.id, null);
					}
				}
				if (worker.override) {
					if (typeof worker.override === 'string') {
						worker.target_zone_type = worker.override;
						let target_zone = this._selectTargetZone(worker);
						worker.override = target_zone.id;
					}
					else {
						worker.target_zone_type = this.zones[worker.override].type;
					}
				}
				else if (this.muster) {
					if (worker.target_zone_type != 'muster') worker.target_zone_id = null;
					worker.target_zone_type = "muster";
				}
				else {
					let routine = this.routines[worker.type];
					let timeframe = moment()
						.hour(this.start_time.hour)
						.minute(this.start_time.minute)
						.second(this.time)
						.format("H:mm");
					let scheduled_to = "";
					worker.target_zone_type = null;
					for (let i in routine) {
						if (moment(timeframe, "H:mm").isSameOrAfter(moment(i, "H:mm"))) {
							worker.target_zone_type = routine[i];
						}
					}

					if (worker.target_zone_type == 'end') {
						worker.target_zone_type = 'start';
						worker.mode = 'end';
					}
				}
				if (worker.target_zone_type) {
					let current_target_zone = {};
					if (worker.target_zone_id) current_target_zone = this.zones[worker.target_zone_id];

					if (current_target_zone.type == worker.target_zone_type || (worker.status == 'at-zone' && worker.zone.type == worker.target_zone_type)) return;

					let target_zone = this._selectTargetZone(worker);
					if (target_zone) {
						worker.target_zone_id = target_zone.id;
						if (worker.status != 'injury') worker.status = 'finding-path';
					}
					else worker.target_zone_id = null;
				}
				else worker.target_zone_id = null;
			},
			_workerDestination(worker) {

				let $sprite = this.sprites[worker.id];
				let target_zone;

				if (worker.status == -1 || worker.status == "injury" || worker.end || worker.waiting_vehicle)
					return;


				let target_zone_id = (worker.override) ? worker.override : worker.target_zone_id;

				if (!target_zone_id) {
					if (this.$worker.hasRoute(worker)) $sprite.stop();
					$sprite.setPath(null);
					worker.route = null;
					this._moveWithinZone(worker);

					return;
				}

				if (this.zones[target_zone_id].type == "break" && worker.mode == "break") worker.mode = "normal";

				if (!this.$worker.hasRoute(worker)) {
					$sprite.stop();
					if (worker.override) {
						this._findPath(worker);
						return;
					}

					if (
						worker.zone.type == "break" &&
						this.zones[target_zone_id].type == "work" &&
						worker.mode == "break"
					) {
						// Worker WILL NOT return to work if...
						if (Math.random() >= worker.chance_good) {
							this._moveWithinZone(worker);
							return;
						}
						worker.mode = "normal";
					} else if (
						worker.zone.type == "restricted" &&
						this.zones[target_zone_id].type != "start" &&
						this.zones[target_zone_id].type != "end" &&
						this.zones[target_zone_id].type != "break" &&
						this.zones[target_zone_id].type != "muster"
					) {
						// Worker WILL return to work if...
						if (Math.random() < worker.safety_chance_good) {
							this._findPath(worker);
							return;
						}
						this._moveWithinZone(worker);
						return;
					}

					this._findPath(worker);

				}
				else {
					this._moveToZone(worker);
				}
			},
			_moveToZone(worker) {

				let $sprite = this.sprites[worker.id];

				if (['going', 'boarding', 'on-board'].includes(worker.status) || !this.$worker.hasRoute(worker)) return;

				if (worker.route[0].vehicle && !worker.in_vehicle) {
					let target_zone = this.$zone.get(worker.target_zone_id);

					let vehicle = worker.route[0].vehicle;
					if (!vehicle) return;
					if (vehicle.status == 'at-zone' && vehicle.zone.id == worker.zone.id) {
						$sprite.setDestination(vehicle.coordinates);
						worker.status = "boarding";
						worker.vehicle_id = vehicle.id;
						if (vehicle.type != 'transport') worker.route[0].path.unshift(vehicle.coordinates);
						else worker.route[0].path[0] = vehicle.coordinates;
						worker.clear_queue = false;
					}
					else if (!worker.driver_id) {
						let driver = this.$worker.getClosestDriver(vehicle);
						// console.log(driver);
						worker.clear_queue = true;
						if (driver) {
							//if (driver.status == 'on-board') return;
							//driver.override = worker.zone.id;
							worker.driver_id = driver.id;
							driver.driver = true;
							driver.return_to = driver.zone.id;

							// setting route to null forces recalculation
							driver.route = null;
							vehicle.route = null;
							vehicle.status = 'finding-path';

						}
					}
				}
				else {
					$sprite.setPath(worker.route[0].path, worker.speed);
					worker.status = "going";
				}
			},
			_resumeWalk(worker) {

				if (worker.status != "going" || !worker.route[0].path) return;

				let $sprite = this.sprites[worker.id];

				var line = turf.lineString(worker.route[0].path);
				var start = turf.point(worker.coordinates);
				var stop = turf.point(route[route.length - 1]);

				route = turf.lineSlice(start, stop, line).geometry.coordinates;
				$sprite.setPath(route, worker.speed);
				worker.status = "going";
			},
			takeBreak() {
				for (let i in this.workers) {
					let worker = this.workers[i];
					if (worker.status == "at-zone" && worker.zone.type == "work") {
						if (Math.random() < worker.chance_bad) {
							worker.target_zone_type = "break";
							worker.mode = "break";
							this._findPath(worker);
						}
					}
				}
			},
			safetyEvents() {
				for (let i in this.workers) {
					let worker = this.workers[i];
					let $sprite = this.sprites[worker.id];
					if (
						worker.status == "at-zone" &&
						(worker.zone.type == "work" || worker.zone.type == "restricted")
					) {
						if (Math.random() < worker.safety_chance_bad) {
							let rand = Math.random();
							if (rand <= 0.3333) {
								worker.target_zone_type = "restricted";
								let target_zone = this._selectTargetZone(worker);
								if (target_zone) {
									worker.target_zone_id = target_zone.id;
									worker.status = 'finding-path';
								}
								this._findPath(worker);
							} else if (rand <= 0.6666) {
								$sprite.stop();
								worker.status = "injury";

								worker.injury = "fall";
							} else {
								$sprite.stop();
								worker.status = "injury";

								worker.injury = "man-down";
							}
						}
					}
				}
			},
			filerWorkersOnMap() {
				const {
					filteredWorkers
				} = this;
				const fWKeys = Object.keys(filteredWorkers);

				const ids = fWKeys.map(i => filteredWorkers[i].id);
				for (const i in this.workers) {
					const worker = this.workers[i];

					if (ids.indexOf(worker.id) === -1) {
						worker.filtered = true;
					} else {
						worker.filtered = false;
					}
				}
			}
		}
	};
</script>
